// Floating photo preview while hovering rows on the index page.
document.addEventListener('DOMContentLoaded', () => {
    const list = document.querySelector('.index-list');
    const preview = document.querySelector('.index-preview');

    if (!list || !preview || !window.matchMedia('(hover: hover)').matches) return;

    const img = preview.querySelector('.index-preview__img');

    list.addEventListener('pointermove', (event) => {
        const x = Math.min(event.clientX + 28, window.innerWidth - preview.offsetWidth - 20);
        const y = Math.min(
            Math.max(event.clientY - preview.offsetHeight / 2, 20),
            window.innerHeight - preview.offsetHeight - 20
        );
        preview.style.transform = `translate(${x}px, ${y}px)`;
    });

    list.querySelectorAll('.index-list__row').forEach((row) => {
        row.addEventListener('mouseenter', () => {
            if (!row.dataset.preview) return;
            img.src = row.dataset.preview;
            preview.classList.add('is-visible');
        });
    });

    list.addEventListener('mouseleave', () => {
        preview.classList.remove('is-visible');
    });
});
